import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Paragraph from '../../../../../../../../components/common/Paragraph';


const EffectiveModalControl = () => {
    const [isModalVisible, setModalVisible] = useState(false);

    const hideModal = () => setModalVisible(false);
    const openModal = () => setModalVisible(true);

    const modalFooter = (
        <Button type="primary" onClick={hideModal}>
            Entendido
        </Button>
    );

    return (
        <>
            <Button
                size="small"
                type="link"
                style={{ paddingLeft: '2px', paddingRight: '2px' }}
                onClick={openModal}
            >
                <h1 className="previousStepForm__title--bold">Control Efectivo de la Persona o Estructura Jurídica</h1>
            </Button>
            <InfoCircleOutlined className="modalBene__info" />
            <Modal footer={modalFooter} visible={isModalVisible} onCancel={hideModal} width={780}>
                <Paragraph strong>Control Efectivo de la Persona o Estructura Jurídica</Paragraph>
                <Paragraph align="justify">
                    Control Efectivo de la Persona o Estructura Jurídica
                    Conforme la Circulr Nº 57 de la Unidad de Análisis Financiero o aquella que la modifique o reemplace, se entiende por Control Efectivo a la(s) persona(s)
                    naturales que, sin perjuicio de poseer directa o indirectamente una participación inferior al 10% del capital o de los derechos a voto de la Entidad, a través de sociedades u otros mecanismos, ejerce el control efectivo en la toma de decisiones de la Entidad, esto es, que tiene la capacidad de tomar decisiones relevantes e imponer dichas resoluciones en la Entidad, ya sea por poseer un número relevante de acciones, contar con la participación necesaria para designar y/o remover a la alta generncia y/o directorio, y/o por disponer del uso, disfrute o beneficios de los activos de propiedad de la Entidad, entre otras circunstancias.
                </Paragraph>
            </Modal>
        </>
    );
};

export default EffectiveModalControl;
